'use strict';

import Vue from 'vue';
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';
// import store from '../store/index';

Vue.use(
  VueSocketio,
  io('https://live.groupmail.net', {
    reconnect: true,
    cookie: false,
    transports: ['polling', 'websocket']
  })
);
